import React from 'react';
// Components
import AboutComponent from './AboutComponent';
import MenuComponent from './MenuComponent';
import RoomsComponent from './RoomsComponent';
import MapComponent from './MapComponent';
import ContactComponent from './ContactComponent';
import PokerComponent from './PokerComponent';
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import BrunchComponent from './BrunchComponent';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid w-full pb-12 h-full'>
      {/* About Section */}
      <AboutComponent />

      {/* Menu Section */}
      <MenuComponent />

      {/* Gallery */}
      <SmallGalleryComponent />

      <BrunchComponent />
      
      {/* Rooms Section */}
      <RoomsComponent />

      {/* Map Section */}
      <MapComponent />

      <PokerComponent />

      {/* Contact Section */}
      {/* <ContactComponent /> */}
    </main>
  );
}

export default HomePageMainContainer;
